'use strict';

import React from 'react';
import PropTypes from 'prop-types';
const AssetUtil = require('../../util/asset');

const propTypes = {
    src: PropTypes.string,
    alt: PropTypes.string,
    className: PropTypes.string,
    longdesc: PropTypes.string, //react does not currently support the longdesc img attribute
    'aria-hidden': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    onClick: PropTypes.func,
    style: PropTypes.object,
};

const defaultProps = {
    src: `${GlobalConfig.StaticUrl}/img/logo-grey-1.svg`,
    alt: '',
    longdesc: '',
    className: '',
    'aria-hidden': false,
    onClick: null,
    style: { width:'162px' },
};

function AssetImage(props) {
    function onClick() {
        if (props.onClick) props.onClick();
    }

    const extraAttrs = {};
    if (!props.alt) {
        extraAttrs['aria-hidden'] = "true";
        extraAttrs['role'] = "presentation";
    }

    return (
        <img
            src={AssetUtil.resolveAssetPath(props.src)}
            alt={props.alt}
            style={props.style}
            className={props.className}
            aria-hidden={props['aria-hidden']}
            onClick={onClick}
            { ...extraAttrs }
        />
    );
}

AssetImage.propTypes = propTypes;
AssetImage.defaultProps = defaultProps;

export default AssetImage;
